import { useEffect, useState } from "react";
import { createEcho } from "../utils/echo";

export interface DriverLocationEvent {
  staff_member_id: string;
  status: "online" | "offline";
  latitude: number | null;
  longitude: number | null;
  updated_at: string;
}

export const useDriverLocationUpdates = (companyId?: string) => {
  const [liveUpdates, setLiveUpdates] = useState<Record<string, DriverLocationEvent>>({});

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || !companyId) return;

    const echo = createEcho(token);
    const channelName = `company.${companyId}.driver-locations`;
    const channel = echo.private(channelName);

    console.debug("[driver-locations] subscribing to", `private-${channelName}`);

    channel.subscription?.bind("pusher:subscription_succeeded", () => {
      console.debug("[driver-locations] subscription succeeded");
    });
    channel.subscription?.bind("pusher:subscription_error", (status: unknown) => {
      console.error("[driver-locations] subscription failed", status);
    });

    const handleLocationUpdate = (event: DriverLocationEvent) => {
      console.debug("[driver-locations] event received", event);
      setLiveUpdates((prev) => ({ ...prev, [event.staff_member_id]: event }));
    };

    channel.listen(".driver-location-updated", handleLocationUpdate);

    return () => {
      channel.stopListening(".driver-location-updated");
      echo.leave(channelName);
    };
  }, [companyId]);

  return liveUpdates;
};
